module.exports = __webpack_public_path__ + "static/media/whiteClose.31aee266.svg";